import * as React from 'react';
import classNames from 'classnames';
import { NvPaginationContext } from './useNvPagination.hooks.esm.js';

var NvPageLengthSelector = function (_a) {
    var className = _a.className;
    var _b = React.useContext(NvPaginationContext), handleKeyPress = _b.handleKeyPress, handlePerPageInputChange = _b.handlePerPageInputChange, numPerPageInput = _b.pagination.numPerPageInput, updatePaginationStateWithDataFromInputs = _b.updatePaginationStateWithDataFromInputs;
    return (React.createElement("div", { className: classNames('nv-pagination-evenly-spaced-box', className) },
        React.createElement("span", null,
            "Show",
            React.createElement("input", { className: "nv-pagination-input", "data-testid": "numPerPageInput", onBlur: updatePaginationStateWithDataFromInputs, onChange: handlePerPageInputChange, onKeyDown: handleKeyPress, value: numPerPageInput }),
            "per page")));
};

export { NvPageLengthSelector as default };
//# sourceMappingURL=NvPageLengthSelector.esm.js.map
